import { RealRewardStep, type RewardInfo } from "@hg/activity-utils"
import Modal from "@hg/modal"
import { useEffect, useState } from "react"

import { getDrawInfo, postDrawContact, type ContactInfo } from "@/services/core"
import { VirtualReward } from "@/components/Lottery/UI"
import { RealReward } from "@/components/Lottery/UI/RealReward"
import Toast from "@/components/Toast"
import RuleModal from "../../RuleModal"

interface Props {
    open: boolean
    onCancel: () => void
    reward?: RewardInfo | null
    prizeType?: "GOODS" | "GIFT" | "MISS" | null
    couponCid: string
}

const ResultModal: React.FC<Props> = (props) => {
    const { open, onCancel, reward, prizeType, couponCid } = props

    const [ruleOpen, setRuleOpen] = useState(false)

    const [step, setStep] = useState<RealRewardStep>(RealRewardStep.EDIT)
    const [contact, setContact] = useState<ContactInfo>({
        name: "",
        phone: "",
        email: "",
        postcode: "",
        address: "",
        province: "",
        city: "",
        county: "",
    })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!open) return
        getDrawInfo().then((res) => {
            if (res.code === 0) {
                const info = res.data.contactInfo?.[couponCid]
                if (info) {
                    setStep(RealRewardStep.PREVIEW)
                    setContact(info as ContactInfo)
                } else {
                    setStep(RealRewardStep.EDIT)
                }
            }
        })
    }, [open, couponCid])

    const handleSubmitContact = async () => {
        setLoading(true)
        try {
            const res = await postDrawContact(couponCid, contact)
            if (res.code === 0) {
                setStep(RealRewardStep.DONE)
            } else {
                Toast.message(res.msg || "-")
            }
        } catch (error: any) {
            Toast.message(error.message || "-")
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal active={open} onClose={onCancel}>
            {prizeType === "GIFT" ? (
                <VirtualReward
                    reward={reward}
                    onClose={onCancel}
                    onClickRule={() => setRuleOpen(true)}
                />
            ) : null}
            {prizeType === "GOODS" ? (
                <RealReward
                    reward={reward}
                    onClose={onCancel}
                    step={step}
                    loading={loading}
                    contact={contact}
                    onContactChange={(c) => setContact(c as unknown as ContactInfo)}
                    onSubmitContact={handleSubmitContact}
                    onStepChange={setStep}
                />
            ) : null}
            <RuleModal open={ruleOpen} onCancel={() => setRuleOpen(false)} />
        </Modal>
    )
}

export default ResultModal
